<template>
  <div class="container">
    <div>
      <h1>{{title}}</h1>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockTtitle',
  props: ['title']
}
</script>

<style scoped lang="stylus">
  .container
    width: 1140px
    margin: 0 auto
    div
      width: 147px
      text-align: center
      h1
        font-size: 31px
        font-weight: 500
        margin: 100px 0 8px 0
      hr
        width: 147px
        display: inline-block
        border: 5px solid #cb212f
        margin: 0 0 50px 0
</style>



// WEBPACK FOOTER //
// src/components/BlockTtitle.vue